import React from "react";
import { PageHeader } from "./PageHeader";

export const Hotels = props => {

    const apartament = [
        {
            "name": "Belle Epoque Apart Residence",
            "address": "ul Siemiradzkiego 2, 30-051 Kraków ",
            "url": "https://belleepoquekrakow.pl/",
            "room1": "Apartament typu studio: 280 zł/doba",
            "room2": "Apartament z sypialnią:  310 zł/doba",
            "room3": "Apartament z sypialnią i balkonem + klimatyzacja: 330 zł/doba",
            "info": "Rezerwacji dokonuje się przez stronę internetową lub telefonicznie. Dodatkowo śniadanie serwowane do apartamentu kosztuje 35 zł i jest wydawane na ustaloną z Gośćmi godzinę. ",
            "email": "biuro@tww.pl",
            "tel": "0048 12 638 02 12",
            "from": "16/08/2019",
            "password": "Zjazd Fizyków"
        }
    ];

    const hotels = [
            {
              "name": "Dom Gościnny UJ Floriańska",
              "address": "ul. Floriańska 49, 31-019 Kraków",
              "url": "http://www.dg.uj.edu.pl/florianska",
              "room1": 270,
              "room2": 380,
              "room3": null,
              "info": "Rezerwacji pokoi dokonuje się telefonicznie lub za pośrednictwem poczty elektronicznej.",
              "email": "dguj@uj.edu.pl",
              "tel": "0048 12 421 12 25",
              "from": "12/08/2019",
              "password": "Zjazd Fizyków"
            },
            {
              "name": "Dom Profesorski UJ im.Stanisława Pigonia",
              "address": "ul. Garbarska 7a, 31-131 Kraków",
              "url": "http://www.dg.uj.edu.pl/garbarska",
              "room1": 290,
              "room2": 400,
              "room3": null,
              "info": "Rezerwacji pokoi dokonuje się telefonicznie lub za pośrednictwem poczty elektronicznej.",
              "email": "pigoniowka@uj.edu.pl",
              "tel": "0048 12 422 30 08",
              "from": "12/08/2019",
              "password": "Zjazd Fizyków"
            },
            {
              "name": "Pokoje gościnne Wydziału FAIS UJ",
              "address": "ul. prof. S. Łojasiewicza 11, 30-348 Kraków",
              "url": "https://fais.uj.edu.pl/wydzial/pokoje-goscinne",
              "room1": 130,
              "room2": 220,
              "room3": null,
              "info": "Rezerwacji pokoi dokonuje się telefonicznie lub za pośrednictwem poczty elektronicznej.",
              "email": "malgorzata.nalodka@uj.edu.pl",
              "tel": "0048 12 664 45 13 ",
              "from": "12/08/2019",
              "password": "Zjazd Fizyków"
            },
            {
              "name": "Hotele Studenckie - Nawojka",
              "address": "ul. Reymonta 11, 30-059 Kraków",
              "url": "https://nawojka.hotelestudenckie.pl/",
              "room1": 95,
              "room2": 110,
              "room3": null,
              "info": "Rezerwacji pokoi dokonuje się telefonicznie lub za pośrednictwem poczty elektronicznej.",
              "email": "nawojka@hotele.studenckie.pl",
              "tel": "0048 12 378 11 00 ",
              "from": "13/06/2019",
              "password": "Zjazd Fizyków"
            },
            {
              "name": "Hotele Studenckie - Żaczek",
              "address": "al.3 Maja 5, 30-063 Kraków",
              "url": "https://zaczek.hotelestudenckie.pl/",
              "room1": 90,
              "room2": 120,
              "room3": 150,
              "info": "Rezerwacji pokoi dokonuje się telefonicznie lub za pośrednictwem poczty elektronicznej.",
              "email": "zaczek@hotele.studenckie.pl",
              "tel": "0048 12 622 11 00 ",
              "from": "12/08/2019",
              "password": "Zjazd Fizyków"
            },
            {
              "name": "Qubus Hotel Kraków ",
              "address": "ul. Nadwiślańska 6, 30-527 Kraków ",
              "url": "https://www.qubushotel.com/",
              "room1": 400,
              "room2": 450,
              "room3": null,
              "info": "Rezerwacji pokoi dokonuje się na stronie www z pośrednictwem kodu rabatowego \"ZFP\"",
              "email": "",
              "tel": "0048 71 782 87 65",
              "from": "18/09/2019",
              "password": "ZFP"
            },
            {
              "name": "Hotel Poleski ",
              "address": "ul. Sandomierska 6, 30-301 Kraków",
              "url": "http://www.hotelpoleski.pl/",
              "room1": 250,
              "room2": 290,
              "room3": null,
              "info": "Rezerwacji pokoi dokonuje się telefonicznie lub za pośrednictwem poczty elektronicznej.",
              "email": "hotel@hotelpoleski.pl",
              "tel": "0048 12 260 54 05",
              "from": "11/06/2019",
              "password": ""
            },
            {
              "name": "Hotel Columbus",
              "address": "ul. Starowiślna 57, 31-038 Kraków",
              "url": "http://www.hotelcolumbus.pl/",
              "room1": 389,
              "room2": 429,
              "room3": null,
              "info": "Rezerwacji pokoi dokonuje się telefonicznie lub za pośrednictwem poczty elektronicznej.",
              "email": "hotel@hotelcolumbus.pl",
              "tel": "0048 12 252 75 50",
              "from": "15/05/2019",
              "password": "Zjazd Fizyków"
            },
            {
              "name": "Hotel Nobilton ",
              "address": "ul. Piłsudskiego 25, 31-110 Kraków",
              "url": "http://www.nobilton.com/",
              "room1": 330,
              "room2": 370,
              "room3": null,
              "info": "Rezerwacji pokoi dokonuje się telefonicznie lub za pośrednictwem poczty elektronicznej.",
              "email": "info@nobilton.pl",
              "tel": "0048 12 430 10 25",
              "from": "18/09/2019",
              "password": ""
            },
            {
              "name": "B&B Hotel Kraków Centrum",
              "address": "ul. Monte Cassino 1, 30-337 Kraków",
              "url": "https://www.hotelbb.pl/pl/krakow",
              "room1": 230,
              "room2": 260,
              "room3": null,
              "info": "Rezerwacji pokoi dokonuje się telefonicznie lub za pośrednictwem poczty elektronicznej.",
              "email": "krakow@hotelbb.com",
              "tel": "0048 12 205 05 10",
              "from": "18/09/2019",
              "password": "Zjazd Fizyków"
            },
            {
              "name": "Park Inn by Radisson Krakow Hotel",
              "address": "ul. Monte Cassino 2, 30-337 Krakow",
              "url": "https://www.parkinn.com/hotel-krakow",
              "room1": 515,
              "room2": 555,
              "room3": null,
              "info": "Rezerwacji pokoi dokonuje się telefonicznie lub za pośrednictwem poczty elektronicznej.",
              "email": "reservations.krakow@parkinn.com",
              "tel": "0048 12 375 55 72",
              "from": "31/08/2019",
              "password": "Zjazd PTF"
            },
            {
              "name": "Novotel Kraków City West",
              "address": "ul. Armii Krajowej 11, 30-150 Kraków",
              "url": "https://www.accorhotels.com",
              "room1": 355,
              "room2": 395,
              "room3": null,
              "info": "Rezerwacji pokoi dokonuje się telefonicznie lub za pośrednictwem poczty elektronicznej.",
              "email": "h3407-sb@accor.com",
              "tel": "0048 12 622 64 00",
              "from": "18/09/2019",
              "password": "Zjazd Fizyków"
            },
            {
              "name": "Hotel Legend",
              "address": "ul. Św. Gertrudy 12, 31-048 Kraków",
              "url": "https://legend-hotel.pl/",
              "room1": 415,
              "room2": 460,
              "room3": null,
              "info": "Rezerwacji pokoi dokonuje się telefonicznie lub za pośrednictwem poczty elektronicznej.",
              "email": "agnieszka.letkiewicz@jordan.pl",
              "tel": "0048 12 354 59 54 wew 310",
              "from": "18/09/2019",
              "password": "ZFP "
            },
            {
              "name": "Hotel Kossak",
              "address": "Plac Kossaka, 31-106 Kraków ",
              "url": "https://hotelkossak.pl/",
              "room1": 530,
              "room2": 590,
              "room3": null,
              "info": "Rezerwacji pokoi dokonuje się telefonicznie lub za pośrednictwem poczty elektronicznej.",
              "email": "kossak@hotelkossak.pl",
              "tel": "0048 12 422 76 86",
              "from": "18/09/2019",
              "password": "Zjazd Fizyków"
            },
           {
            "name": "Hotele Studenckie - Krakowiak",
            "address": "ul. Armii Krajowej 9, 30-150 Kraków",
            "url": "https://www.up.krakow.pl/student/domy-studenckie/ds-krakowiak",
            "room1": 109,
            "room2": 162,
            "room3": null,
            "info": "Rezerwacji pokoi dokonuje się telefonicznie lub za pośrednictwem poczty elektronicznej.",
            "email": "krakowiak@up.krakow.pl",
            "tel": "0048 12 662 64 55",
            "from": "13/08/2019",
            "password": ""
        }
    ];

    return (
        <React.Fragment>
            <PageHeader title="Hotele" />
            <div className="content-wrapper">
                <div className="main-content">
                    Dla wygody uczestników 45 Zjazdu Fizyków Polskich dokonaliśmy wstępnych rezerwacji w hotelach i domach gościnnych o różnym standardzie na terenie Krakowa. Dostępność hoteli w puli ograniczona jest czasowo. <br />
                    W celu skorzystania z obniżonych cen należy użyć hasła podanego w tabeli poniżej podczas rezerwacji.
                    <p className="alert">
                    <b>Organizatorzy nie pośredniczą pomiędzy uczestnikami Zjazdu i hotelami w sprawie rezerwacji noclegów.</b>
                    </p>
                    <br />

                    <h4>Lista hoteli</h4>
                    {hotels.map((hotel) => {
                        return (
                            <div class="hotel">
                                <div class="detail">
                                    <b class="name">{hotel.name}</b>
                                    <div>{hotel.address}</div>
                                    {hotel.url && <div><a href={hotel.url}>{hotel.url}</a></div>}
                                    {hotel.email && <div>email: <a href={"mailto:"+hotel.email}>{hotel.email}</a></div>}
                                    {hotel.tel && <div>tel.: {hotel.tel}</div>}
                                </div>
                                <div class="rooms">
                                    <div class="room-header">Pokoje w cenach:</div>
                                    {hotel.room1 && <div>1 osobowy - <b>{hotel.room1} zł</b></div>}
                                    {hotel.room2 && <div>2 osobowy - <b>{hotel.room2} zł</b></div>}
                                    {hotel.room3 && <div>3 osobowy - <b>{hotel.room3} zł</b></div>}
                                    <div class="info">
                                        Oferta dostępna do dnia: <b>{hotel.from}</b>
                                        {hotel.password && <span> na hasło: <b>{hotel.password}</b></span>}
                                    </div>
                                    {hotel.info && <div class="info">{hotel.info}</div>}
                                </div>
                            </div>
                        );
                    })}
                    <h4>Lista apartamentów</h4>
                    {apartament.map((apartament) => {
                        return (
                            <div class="hotel">
                                <div class="detail">
                                    <b class="name">{apartament.name}</b>
                                    <div>{apartament.address}</div>
                                    {apartament.url && <div><a href={apartament.url}>{apartament.url}</a></div>}
                                    {apartament.email && <div>email: <a href={"mailto:"+apartament.email}>{apartament.email}</a></div>}
                                    {apartament.tel && <div>tel.: {apartament.tel}</div>}
                                </div>
                                <div class="rooms">
                                    <div class="room-header">Pokoje w cenach:</div>
                                    {apartament.room1 && <div><b>{apartament.room1}</b></div>}
                                    {apartament.room2 && <div><b>{apartament.room2}</b></div>}
                                    {apartament.room3 && <div><b>{apartament.room3}</b></div>}
                                    <div class="info">
                                        Oferta dostępna do dnia: <b>{apartament.from}</b>
                                        {apartament.password && <span> na hasło: <b>{apartament.password}</b></span>}
                                    </div>
                                    {apartament.info && <div class="info">{apartament.info}</div>}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </React.Fragment>
    );
};

Hotels.propTypes = {};
